import { IProductV1 } from "../../entities"
import { ApiRequester } from "../ApiRequester"

interface RequestDataShape {
	filter: {
		id: string
	}
	update: {
		name?: string
	}
}

interface ResponseDataShape {
	success: boolean
	data: IProductV1
}

export async function productUpdateApi(payload: RequestDataShape, token: string) {
	const endpoint = "/product/update/v1"
	const requester = new ApiRequester<RequestDataShape, ResponseDataShape>(endpoint)
	const response = await requester.sendRequest(payload, token)
	return response.data
}
